/**
 * Reusable checkbox component
 */

import { forwardRef } from 'react';
import './Checkbox.css';

/**
 * Checkbox component with label
 * @param {Object} props - Component props
 * @param {string} props.label - Checkbox label
 * @param {string} props.error - Error message
 * @returns {React.ReactElement} Checkbox element
 */
const Checkbox = forwardRef(function Checkbox({
  label,
  error,
  className = '',
  id,
  ...props
}, ref) {
  const checkboxId = id || `checkbox-${label?.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div className={`checkbox-group ${error ? 'checkbox-group--error' : ''} ${className}`}>
      <label htmlFor={checkboxId} className="checkbox-group__label">
        <input
          ref={ref}
          type="checkbox"
          id={checkboxId}
          className="checkbox-group__input"
          {...props}
        />
        <span className="checkbox-group__checkmark" />
        <span className="checkbox-group__text">{label}</span>
      </label>
      {error && (
        <span className="checkbox-group__error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
});

export default Checkbox;
